import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { BodyOf, ResponseOf } from "../../core/api";
import useApi from "../../shared/hooks/useApi";

export function usePromptTestingRun(
  mutOptions?: Omit<
    UseMutationOptions<
      ResponseOf<"post", "./prompt_testing/run">,
      Error,
      BodyOf<"post", "./prompt_testing/run">
    >,
    "mutationFn"
  >
) {
  const { api } = useApi();

  return useMutation({
    mutationFn: async (data: BodyOf<"post", "./prompt_testing/run">) => {
      const result = await api.post("./prompt_testing/run", {
        body: data,
      });
      return result;
    },
    ...mutOptions,
  });
}
